<script lang="ts">
import { defineComponent } from "vue";
import TarifauswahlElement from "@/components/tarif/TarifauswahlElement.vue";

export default defineComponent({
  name: "Tarifauswahl",
  emits: [],
  components: { TarifauswahlElement },
  props: {
    tarifauswahlInformationen: Array,
  },
  setup(props) {
    return {
      props,
    };
  },
});
</script>

<template>
  <div class="o-grid sticky">
    <div
      class="o-grid__cell o-grid__cell--12 o-grid__cell--offset-0 o-grid__cell--9-480 o-grid__cell--offset-3-480 o-grid__cell--8-768 o-grid__cell--offset-3-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y"
    >
      <div class="radio-tarif o-grid">
        <tarifauswahl-element
          v-for="tarifauswahlInformation in props.tarifauswahlInformationen"
          :key="tarifauswahlInformation.tarifNummer"
          :tarifauswahlInformation="tarifauswahlInformation"
          :anzahlElemente="props.tarifauswahlInformationen.length"
        />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
